import { IS_LOCAL_ENV } from "../App";
import { _axios } from "./config";
import qs from "qs";

export const getShippingRates = async () => {
  try {
    const { data } = await _axios.get(`/api/shippingRates?limit=0`);
    return data;
  }
  catch (err) {
    IS_LOCAL_ENV && console.error(err);
    throw err;
  }
}

export const getPurchases = async (page, sortProp, queryObj) => {

  const stringifiedQuery = Object.keys(queryObj).length
    ? qs.stringify({ where: queryObj })
    : "";

  try {
    const { data } = await _axios.get(`/api/purchases?page=${page}` + (stringifiedQuery ? `&${stringifiedQuery}` : "") + (sortProp ? `&sort=${sortProp}` : ""));
    return data;
  }
  catch (err) {
    IS_LOCAL_ENV && console.error(err);
    throw err;
  }
}

export const updateShippingRate = async (rateId, props) => {
  try {
    const { data } = await _axios.patch(`/api/shippingRates/${rateId}`, props);
    return data;
  }
  catch (err) {
    IS_LOCAL_ENV && console.error(err);
    throw err;
  }
}

export const createShippingRate = async (props) => {
  try {
    const { data } = await _axios.post(`/api/shippingRates`, props);
    return data;
  }
  catch (err) {
    IS_LOCAL_ENV && console.error(err);
    throw err;
  }
}

export const deleteShippingRate = async (rateId) => {
  try {
    const { data } = await _axios.delete(`/api/shippingRates/${rateId}`);
    return data;
  }
  catch (err) {
    IS_LOCAL_ENV && console.error(err);
    throw err;
  }
}

export const updatePurchaseStatus = async (id, status) => {
  try {
    const { data } = await _axios.patch(`/api/purchases/${id}`, { status: status });
    return data;
  }
  catch (err) {
    IS_LOCAL_ENV && console.error(err);
    throw err;
  }
}